// Owner Console API client — relative paths so the dev proxy + production
// ingress both route through /api correctly.

const BASE = '/api/owner';

async function _fetch(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  if (!res.ok) {
    let detail = res.statusText;
    try { detail = (await res.json()).detail || detail; } catch { /* noop */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

export const ownerApi = {
  me: () => _fetch('/me'),
  overview: () => _fetch('/overview'),
  listAdmins: () => _fetch('/admins'),
  grantAdmin: (email, notes) =>
    _fetch('/admins/grant', { method: 'POST', body: JSON.stringify({ email, notes }) }),
  revokeAdmin: (email) =>
    _fetch('/admins/revoke', { method: 'POST', body: JSON.stringify({ email }) }),

  queryAccounts: (body) =>
    _fetch('/accounts/query', { method: 'POST', body: JSON.stringify(body || {}) }),
  getAccount: (account_id) => _fetch(`/accounts/${encodeURIComponent(account_id)}`),
  patchAccount: (account_id, body) =>
    _fetch(`/accounts/${encodeURIComponent(account_id)}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
  recomputeHealth: (account_id) =>
    _fetch(`/accounts/${encodeURIComponent(account_id)}/recompute-health`, { method: 'POST' }),

  queryPeople: (search) =>
    _fetch('/people/query', { method: 'POST', body: JSON.stringify({ search }) }),
  getPerson: (person_id) => _fetch(`/people/${encodeURIComponent(person_id)}`),
  getUser: (user_id) => _fetch(`/users/${encodeURIComponent(user_id)}`),
  inspect: ({ email, user_id, person_id }) => {
    const qs = new URLSearchParams();
    if (email) qs.set('email', email);
    if (user_id) qs.set('user_id', user_id);
    if (person_id) qs.set('person_id', person_id);
    return _fetch(`/identity/inspect?${qs.toString()}`);
  },

  resetIdentity: (body) =>
    _fetch('/identity/reset', { method: 'POST', body: JSON.stringify(body) }),
  reinvite: (body) =>
    _fetch('/identity/reinvite', { method: 'POST', body: JSON.stringify(body) }),

  events: ({ account_id, person_id, organization_id, event_type, limit = 100 } = {}) => {
    const qs = new URLSearchParams();
    if (account_id) qs.set('account_id', account_id);
    if (person_id) qs.set('person_id', person_id);
    if (organization_id) qs.set('organization_id', organization_id);
    if (event_type) qs.set('event_type', event_type);
    qs.set('limit', String(limit));
    return _fetch(`/events?${qs.toString()}`);
  },
  identityAudit: (limit = 100) => _fetch(`/identity/audit?limit=${limit}`),
};
